import { TableDataGridV2 } from "../../../../../components/TableDataGridV2"
import { Column } from "../../../../../components/TableDataGridV2/types"
import { PesquisarCheque } from "../../../../../types/api/financeiro/pesquisar-cheques"

export default function Listagem() {
    return (
        <>
            <TableDataGridV2
                urlParams
                columns={colunas}
                url="/financeiro/cheques/pesquisar-cheques-devolvidos"
                queryKey="listar-todos-cheques-devolvidos"
                pagination="server"
            />
        </>
    )
}

const colunas: Column<PesquisarCheque>[] = [
    { id: 'numero_cheque', type: 'text', label: 'Número do cheque', width: 100, filter: true, sortable: true },
    { id: 'sequencia_cheque', type: 'text', label: 'Sequência do cheque', width: 100 },
    { id: 'data_vencimento', type: 'date', label: 'Data de vencimento', width: 100 , filter: true, sortable: true},
    { id: 'valor_cheque', type: 'monetary', label: 'Valor do cheque', width: 100, numeric: true, filter: true, sortable: true },
    { id: 'nome_emissor', type: 'text', label: 'Nome do emissor', width: 100, filter: true, sortable: true },
    { id: 'banco_cheque', type: 'text', label: 'Banco', width: 100 },
    { id: 'agencia_bco_cheque', type: 'text', label: 'Agência', width: 100 },
    { id: 'conta_bco_cheque', type: 'text', label: 'Conta', width: 100 },
    { id: 'data_entrada_cheque', type: 'date', label: 'Data de entrada', width: 100, filter: true, sortable: true },
    { id: 'data_baixa', type: 'date', label: 'Data de baixa', width: 100, filter: true, sortable: true },
    { id: 'observacoes', type: 'text', label: 'Observações', width: 100 },
]
